import { getCtaButtonNumberTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const ctaButtonNumberConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Call CTA #2",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "number",
          label: "Phone number",
          placeholder: "(000) 000-0000",
        },
        {
          type: "input",
          name: "text",
          label: "Text below the phone number",
          placeholder: "Text below the phone number",
        },
        {
          type: "selectbox",
          name: "hrefType",
          label: "Select button action",
          items: [
            { value: "tel:", text: "Start a phone call" },
            { value: "", text: "Open link" },
          ],
        },
        {
          type: "input",
          name: "url",
          label: "URL or phone number",
          placeholder: "URL or phone number",
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
        {
          type: "colorinput",
          name: "bgColor",
          label: "Button color",
        },
        {
          type: "colorinput",
          name: "borderColor",
          label: "Border color",
        },
      ],
    },
    initialData: {
      bgColor: "#1CB91F",
      borderColor: "#1DA220",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getCtaButtonNumberTemplate({
        number: data.number,
        text: data.text,
        url: data.url,
        bgColor: data.bgColor,
        borderColor: data.borderColor,
        hrefType: data.hrefType,
        tab: data.openLink,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};

export { ctaButtonNumberConfig };
